import { DOMReady } from "./utils/DOMHelpers";
import installmentCalculatorController from "./controller/installmentCalculatorController";

DOMReady(async () => {
    const { init: initInstallmentCalculatorController } = installmentCalculatorController();

    await initInstallmentCalculatorController();
});
